/**
 * 设置模板颜色
 * @param {*} color 
 */
export function setColor(color){
    return `style="color:${color}"`;
}